export default function setBodyImage( urlString ) {
    // document.body.style.backgroundImage = 'url("../images/score_background.png")';
    // document.body.style.backgroundImage = `url('" + ${urlString} + "')`;
    document.body.style.setProperty(`background-image`, `url( ${urlString} )`);
    
}